//
// LayoutOverlayMapViewportOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";

var LayoutOverlayMapViewportOptions = createModule("gtl::LayoutOverlayMapViewportOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        yMin: 6,
        yMax: 6,
        xMax: 6,
        xMin: 6,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutOverlayMapViewportOptions;
